/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ConnectInputs */

const en_connect = /** @type {(inputs: ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect.`)
};

const es_connect = /** @type {(inputs: ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecta.`)
};

const fr_connect = /** @type {(inputs: ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez.`)
};

const de_connect = /** @type {(inputs: ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinden.`)
};

const ja_connect = /** @type {(inputs: ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`繋がる。`)
};

const zh_connect = /** @type {(inputs: ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连接。`)
};

const ar_connect = /** @type {(inputs: ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تواصل.`)
};

const id_connect = /** @type {(inputs: ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungkan.`)
};

const it_connect = /** @type {(inputs: ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connetti.`)
};

const ru_connect = /** @type {(inputs: ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Соединяй.`)
};

const pt_connect = /** @type {(inputs: ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecte.`)
};

const ko_connect = /** @type {(inputs: ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연결.`)
};

/**
* | output |
* | --- |
* | "Connect." |
*
* @param {ConnectInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const connect = /** @type {((inputs?: ConnectInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ConnectInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_connect(inputs)
	if (locale === "es") return es_connect(inputs)
	if (locale === "fr") return fr_connect(inputs)
	if (locale === "de") return de_connect(inputs)
	if (locale === "ja") return ja_connect(inputs)
	if (locale === "zh") return zh_connect(inputs)
	if (locale === "ar") return ar_connect(inputs)
	if (locale === "id") return id_connect(inputs)
	if (locale === "it") return it_connect(inputs)
	if (locale === "ru") return ru_connect(inputs)
	if (locale === "pt") return pt_connect(inputs)
	return ko_connect(inputs)
});